import { Routes } from '@angular/router';
import {
  authGuard,
  loginGuard,
  selectOrgGuard,
  LoginComponent,
  CallbackComponent,
  SelectOrgComponent,
} from '@mbai/multi-tenant-common-auth-ng';
import { partnerMaterialsGuard } from './core/guards/partner-materials.guard';
import { userManagementGuard } from './core/guards/user-management.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  {
    path: 'select-org',
    component: SelectOrgComponent,
    canActivate: [selectOrgGuard],
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'dashboard',
          },
          {
            path: 'dashboard',
            data: { name: 'Dashboard' },
            loadComponent: () =>
              import('./features/v2/dashboard/dashboard.component').then(
                (m) => m.DashboardComponent
              ),
          },
          {
            path: 'projects',
            data: { name: 'Projects' },
            loadComponent: () =>
              import('./features/v2/projects/projects.component').then(
                (m) => m.ProjectsComponent
              ),
          },
          {
            path: 'create-project',
            data: { name: 'New Project' },
            loadComponent: () =>
              import('./features/v2/create-project/create-project.component').then(
                (m) => m.CreateProjectComponent
              ),
          },
          {
            path: 'project-details/:projectId',
            data: { name: 'Project Details' },
            loadComponent: () =>
              import('./features/v2/project-details/project-details.component').then(
                (m) => m.ProjectDetailsComponent
              ),
          },
          {
            path: 'clients',
            data: { name: 'Clients' },
            loadComponent: () =>
              import('./features/v2/clients/clients.component').then(
                (m) => m.ClientsComponent
              ),
          },
          {
            path: 'user-management',
            data: { name: 'User Management' },
            canActivate: [userManagementGuard],
            loadComponent: () =>
              import('./features/user-management/components/user-management/user-management.component').then(
                (m) => m.UserManagementComponent
              ),
          },
          {
            path: 'usage',
            data: { name: 'Usage' },
            canActivate: [userManagementGuard],
            loadComponent: () =>
              import('./features/v2/usage-billing/usage-billing.component').then(
                (m) => m.UsageBillingComponent
              ),
          },
          {
            path: 'deal-builder',
            data: { name: 'Partner Deal Builder' },
            canActivate: [partnerMaterialsGuard],
            loadComponent: () =>
              import('./features/partner-materials/partner-deal-builder/partner-deal-builder.component').then(
                (m) => m.PartnerDealBuilderComponent
              ),
          },
          {
            path: 'overview',
            data: { name: 'Overview' },
            canActivate: [partnerMaterialsGuard],
            loadComponent: () =>
              import('./features/partner-materials/partner-overview/partner-overview.component').then(
                (m) => m.PartnerOverviewComponent
              ),
          },
          {
            path: 'sales-guide',
            data: { name: 'Sales Guide' },
            canActivate: [partnerMaterialsGuard],
            loadComponent: () =>
              import('./features/partner-materials/partner-sales-guide/partner-sales-guide.component').then(
                (m) => m.PartnerSalesGuideComponent
              ),
          },
          {
            path: 'user-guide',
            data: { name: 'User Guide' },
            loadComponent: () =>
              import('./features/user-guide/user-guide.component').then(
                (m) => m.UserGuideComponent
              ),
          },
          {
            path: 'video',
            data: { name: 'Video' },
            loadComponent: () =>
              import('./features/video-guide/video-guide.component').then(
                (m) => m.VideoGuideComponent
              ),
          },
        ],
      },
      {
        path: 'unauthorized-access',
        loadComponent: () =>
          import('./shared/components/unauthorized-access-page/unauthorized-access-page.component').then(
            (m) => m.UnauthorizedAccessPageComponent
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import(
            './shared/components/page-not-found/page-not-found.component'
          ).then((m) => m.PageNotFoundComponent),
      },
    ],
  },
];
